import { Row } from '@tanstack/react-table';
import cn from 'classnames';
import { AnimatePresence } from 'framer-motion';
import React from 'react';

import { CellComponent } from '../CellComponent';

interface IRowComponentProps<TableRowRawData extends { id: number }> {
  cRef?: React.Ref<HTMLTableRowElement>;
  isChecked?: boolean;
  height?: number;
  row: Row<TableRowRawData>;
  extendedRowId?: number | null;
  extendedRowContent?: React.ReactNode;
  className?: string;
  onRowClick?: (event: React.MouseEvent<HTMLTableRowElement>) => void;
  'data-index'?: number;
}

const RowComponent = <T extends { id: number }>({
  cRef,
  height,
  row,
  extendedRowId,
  extendedRowContent,
  className,
  onRowClick,
  'data-index': dataIndex,
}: IRowComponentProps<T>) => {
  const rowIsExtended = row.original.id === extendedRowId;

  return (
    <>
      <tr
        ref={cRef}
        data-index={dataIndex}
        style={{
          height,
        }}
        onClick={onRowClick}
        className={cn({
          className: className,
          '!bg-light-gray-2': !className && Number(row.index) % 2 === 0,
          '!bg-transparent': !className && Number(row.index) % 2 !== 0,
        })}
      >
        {row ? (
          row
            .getVisibleCells()
            .map(cell => (
              <CellComponent
                key={cell.id}
                columnDef={cell.column.columnDef.cell}
                width={cell.column.getSize()}
                height={height}
                context={cell.getContext()}
              />
            ))
        ) : (
          <td style={{ height }}>-</td>
        )}
      </tr>
      <AnimatePresence>{rowIsExtended && extendedRowContent}</AnimatePresence>
    </>
  );
};

export { RowComponent };
